<template>
  <!-- 课程 -->
  <div>
    <div v-if="arr_tb != []">
      <div class="videos">
        <div class="videos_class" v-for="(item,index) in arr_tb"
          :key="index"
          @click="infobtn(item)"
        >
          <img :src="item.cs_picture" alt="">
          <div class="clear">
              <p class="fl">{{list[item.subject_id - 1].name}}</p> 
              <p class="fl">{{item.cs_name}}</p>                        
          </div>
        </div>
      </div>
      <div v-if="nomore && arr_tb.length>10" class="zanwu">暂无更多</div>
    </div>
    <div v-if="arr_tb.length==0" class="zanwu">暂无课程</div>
  </div>
</template>

<script>
import URL from "../api/index";
import VueEvent from "../model/VueEvent";
import Vue from "vue";
import { List } from "vant";

Vue.use(List);
export default {
  name: "",
  data() {
    return {
      arr_tb: [],
      ashow: true,
      top_id: 5,
      grade_id: 0,
      subgect_id: 0,
      press_id: 0,
      page_id: 1,
      word: "",
      icoType: "",
      nomore: false,
      state: 0,
      list:[
          {id:'1',name:'语文'},
          {id:'2',name:'数学'},
          {id:'3',name:'英语'},
      ]
    };
  },
  watch: {
    top_id: function(data) {
      this.http_tb(this.top_id);
    },
    subgect_id: function(data) {
      this.http_tb(this.subgect_id);
    },
    grade_id: function(data) {
      this.http_tb(this.grade_id);
    },
    word: function(data) {
      this.http_tb(this.word);
    },
    press_id: function(data) {
      this.http_tb(this.press_id);
    }
  },
  mounted() {
    window.addEventListener("scroll", this.scrollBottom);

    this.icoType = this.$route.query.icoType;
    var that = this;
    VueEvent.$on("nianji", function(data) {
      that.grade_id = data;
      that.arr_tb = [];
      that.word = "";
      that.page_id = 1;
      that.http_tb();
    });
    VueEvent.$on("kemu", function(data) {
      that.subgect_id = data;
      that.arr_tb = [];
      that.page_id = 1;
      that.http_tb();
    });
    VueEvent.$on("topid", function(data) {
      that.top_id = data;
      that.arr_tb = [];
      that.page_id = 1;
      that.http_tb();
    });
    VueEvent.$on("banben", function(data) {
      that.press_id = data;
      that.arr_tb = [];
      that.page_id = 1;
      that.http_tb(that.press_id);
      // that.http_tb();
    });
    VueEvent.$on("word", function(data) {
      that.word = data;
      that.arr_tb = [];
      that.page_id = 1;
      // that.nomore = false;
      that.http_tb();
    });

    that.http_tb();
  },
  methods: {
    scrollBottom() {
      var that = this;
      let innerHeight = document.querySelector("#app").clientHeight;
      let outerHeight = document.documentElement.clientHeight;
      let scrollTop = document.documentElement.scrollTop;
      if (innerHeight < outerHeight + scrollTop) {
        if (that.state == 0) {
          that.page_id += 1;
          that.http_tb_one();
        }
      }
    },
    go() {
      this.$router.push("/course");
    },
    infobtn(item) {
      this.$router.push({
        name: "newclassdetails",
        query: {
          csid: item.id,
          icoType: this.icoType,
          icotype: "1"
        }
      });
    },
    async http_tb() {
      var that = this;
      await this.$axios({
        method: "post",
        url: URL.get_course_list,
        data: {
          keywords: that.word,
          top_id: that.top_id,
          grade_id: that.grade_id,
          subject_id: that.subgect_id,
          press_id: that.press_id,
          page: that.page_id
        }
      }).then(res => {
        that.state = res.data.state;
        if (res.data.state == 1) {
          that.nomore = true;
          return false;
        }
          that.arr_tb = res.data.result;
      });
    },
    async http_tb_one() {
      var that = this;
      await this.$axios({
        method: "post",
        url: URL.get_course_list,
        data: {
          keywords: that.word,
          top_id: that.top_id,
          grade_id: that.grade_id,
          subject_id: that.subgect_id,
          press_id: that.press_id,
          page: that.page_id
        }
      }).then(res => {
        that.state = res.data.state;
        if (res.data.state == 1) {
          that.nomore = true;
          return false;
        }
          that.arr_tb = that.arr_tb.concat(res.data.result);
      });
    }
  }
};
</script>

<style scoped>
.videos {
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.videos_class:nth-child(2n){
  margin-right: 0;
}
.videos_class{
  width: 48%;
  border-radius: 0.26666rem;
  float: left;
  margin-right: 0.13333rem;
  margin-bottom: 0.26666rem;
  background-color: #fff;
  box-shadow: 0rem 0rem 0.32rem rgba(51, 51, 51, 0.24);
}


.videos_class img {
  border-top-left-radius: 0.26666rem;
  border-top-right-radius: 0.26666rem;
  width: 100%;
  height: 96px;
  border: none;
}

.videos_class div {
  font-size: 0.32rem;
  height: 20px;
}
.videos_class div p:first-child{
  line-height: 0.42666rem;
  background-color: #ff7038;
  margin: 0 0.26666rem;
  width: 0.96rem;
  border-top-left-radius: 0.16rem;
  border-bottom-right-radius: 0.16rem;
  text-align: center;
  color: #f2f2f2;
}
.videos_class div p:last-child{
  line-height: 0.42666rem;
  width: 50%;
  overflow:hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
}
.zanwu {
  text-align: center;
  line-height: 60px;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/CourseTongbu.vue